module.exports = __webpack_public_path__ + "img/del.d28080f7.svg";